export default {
  default: () => import("/root/injective/injective-bridge/layouts/default.vue").then(m => m.default || m),
  plain: () => import("/root/injective/injective-bridge/layouts/plain.vue").then(m => m.default || m)
}